window.prefixSearchHistory = 'search-history'
moment.loadPersian();

// change tabs event function
$(function () {
  const tabButton = $(".js-tab-nav .js-tab-nav-header button, .js-tab-nav .js-tab-nav-header a")
  var firstTabID = $('.js-search-holder-landing').attr('id') || tabButton.attr('data-tab') || tabButton.attr('href')
  createLocalStorageKey(firstTabID)

  tabButton.click(function (event) {
    event.preventDefault();
    createLocalStorageKey($(this).attr('data-tab') || $(this).attr("href"))
  })

  // click event on remove all button
  $(".js-search-history-remove-all").click(function (event) {
    event.preventDefault();
    window.localStorage.setItem(`${window.prefixSearchHistory}-${activeIDFinder()}`, `[]`)
    createSearchHistoryCard()
  })
})

// find active ID
function activeIDFinder() {
  let id = $('.search-holder').find(".js-tab-nav").find(".js-tab-content>div.active").attr('id') || $('.js-search-holder-landing').attr('id')
  if (id !== 'trip-tab') return id
  else return `${findTourType()}${id}`
}

// create perfix for tour tab key
function findTourType() {
  switch ($(".js-booking-section").find(".js-tour-wrapper-item.is-active").attr('id')) {
    case 'js-online-tour-section': return `online-`
    case 'js-offline-tour-section': return `offline-`
    default: return ''
  }
}

// add new item or change sort items in local storage
window.updateLocalStorage = function (key, item) {
  // key: string; item: {value: any, baseUrl: string, expire: string}
  let keyData = JSON.parse(window.localStorage.getItem(key))
  const index = keyData.findIndex(data => data.baseUrl == item.baseUrl)

  if (index !== -1) keyData.splice(index, 1)

  keyData = [
    item,
    ...keyData
  ]
  window.localStorage.setItem(key, JSON.stringify(keyData.slice(0, 5)))
}

// remove specific item from local storage
function removeLocalStorage(key, url) {
  // key: string; url: string
  let keyData = JSON.parse(window.localStorage.getItem(key))
  keyData = keyData.filter(item => item.baseUrl !== url)
  window.localStorage.setItem(key, JSON.stringify(keyData))
}

//create card and check expire date
window.createSearchHistoryCard = function () {
  $('.js-search-history-loading').css("display", 'block').css("height", '87px')
  let identifier = activeIDFinder()
  let searchHistory = JSON.parse(window.localStorage.getItem(`${window.prefixSearchHistory}-${identifier}`))
    ?.filter(item => moment().isSameOrBefore(item.expire, 'day'))
  window.localStorage.setItem(
    `${window.prefixSearchHistory}-${identifier}`,
    JSON.stringify(searchHistory)
  )

  $('.js-search-history-items').empty()
  $('.js-search-history').css("display", Boolean(searchHistory.length) ? '' : 'none')

  if (Boolean(searchHistory.length)) {
    searchHistory.forEach(searchItem => {
      $('.js-search-history-items').append(
        `<div class="search-history__item">
            <a class="search-history__content" href="${searchItem.baseUrl}">
              ${fillerAdaptor(identifier, searchItem.value)}
            </a>
            <button class="search-history__item-remove hide-in-not-phone icon-trash js-search-history-item-remove"></button>
          </div>`
      )
    })

    // click event on remove item button
    $(".js-search-history-item-remove").click(function (event) {
      event.preventDefault();
      const targetElement = $(this).closest('.search-history__item')

      removeLocalStorage(
        `${window.prefixSearchHistory}-${activeIDFinder()}`,
        targetElement.find('.search-history__content').attr('href')
      )
      targetElement.remove()
      createSearchHistoryCard()
    })
  }

  $('.js-search-history-loading').css("display", 'none')
}

// add property in local storage
function createLocalStorageKey(identifier) {
  // identifier: string
  if (identifier === 'trip-tab') {
    let prefixID = findTourType()
    if (!Boolean(window.localStorage.getItem(`${window.prefixSearchHistory}-${prefixID}${identifier}`)))
      window.localStorage.setItem(`${window.prefixSearchHistory}-${prefixID}${identifier}`, `[]`)
  }
  else if (Boolean(identifier) && !Boolean(window.localStorage.getItem(`${window.prefixSearchHistory}-${identifier}`))) {
    window.localStorage.setItem(`${window.prefixSearchHistory}-${identifier}`, `[]`)
  }
  createSearchHistoryCard()
}

// filler content function
function fillerAdaptor(identifier, item) { // edit this adaptor
  switch (identifier) {
    case 'flight-tab': case 'internal-flight-tab':
      return flightSearchHistoryContent(item)
    case 'hotel-tab': case 'internal-hotel-tab':
      return hotelSearchHistoryContent({ ...item, identifier: identifier })
    case 'offline-trip-tab':
      return offlineTripSearchHistoryContent(item)
    case 'online-trip-tab':
      return onlineTripSearchHistoryContent(item)
    case 'trip-tab':
      return tripSearchHistoryContent(item)
    case 'insurance-tab':
      return insuranceSearchHistoryContent(item)
    case 'cip-tab':
      return cipSearchHistoryContent(item)
    case 'travel-service-tab':
      return travelServiceSearchHistoryContent(item)
    case 'domestic-rail-tab':
      return railSearchHistoryContent(item)
      case 'ship-tab': case 'internal-ship-tab':
      return shipSearchHistoryContent(item)
    default:
      return 'تاریخچه جستجو'
  }
}

// fill content of flight tabs
function flightSearchHistoryContent(item) {
  if (item.routeType !== "severalWay") {
    return `
      <div class="search-history__title">
      <span>${item.fromCity.title}</span><i class="${item.routeType === 'oneWay' ? 'icon-left' : 'icon-exchange'}"></i><span>${item.toCity.title}</span>
      </div>
      <div class="search-history__subtitle">${moment(item.startDateValue).format("jDD jMMMM")}${item.routeType === 'twoWay' ? ` تا ${moment(item.endDateValue).format("jDD jMMMM")}` : ``
      }</div>
    `
  } else {
    return `
      <div class="search-history__title">
        <span>پرواز چند مسیره</span>
      </div>
      <div class="search-history__subtitle">${moment(item.date[0]).format("jDD jMMMM")}${item.date[0] !== item.date.slice(-1)[0] ? ` تا ${moment(item.date.slice(-1)[0]).format("jDD jMMMM")}` : ''
      }</div>
    `
  }
}

// fill content of ship tabs
function shipSearchHistoryContent(item) {
  if (item.routeType !== "severalWay") {
    return `
      <div class="search-history__title">
      <span>${item.fromCity.title}</span><i class="${item.routeType === 'oneWay' ? 'icon-left' : 'icon-exchange'}"></i><span>${item.toCity.title}</span>
      </div>
      <div class="search-history__subtitle">${moment(item.startDateValue).format("jDD jMMMM")}${item.routeType === 'twoWay' ? ` تا ${moment(item.endDateValue).format("jDD jMMMM")}` : ``
      }</div>
    `
  } else {
    return `
      <div class="search-history__title">
        <span>کشتی چند مسیره</span>
      </div>
      <div class="search-history__subtitle">${moment(item.date[0]).format("jDD jMMMM")}${item.date[0] !== item.date.slice(-1)[0] ? ` تا ${moment(item.date.slice(-1)[0]).format("jDD jMMMM")}` : ''
      }</div>
    `
  }
}

// fill content of hotel tabs
function hotelSearchHistoryContent(item) {
  return `
  <div class="search-history__title">
  <span>${item.hotelTitle}</span>
</div>
<div class="search-history__subtitle">${moment(item.hotelStartDateEn).format("jDD jMMMM")} تا ${moment(item.hotelEndDateEn).format("jDD jMMMM")
    }</div>
  `
}

// fill content of offline tour
function offlineTripSearchHistoryContent(item) {
  return `
    <div class="search-history__title">
      <span>${item.title}</span>
    </div>
  `
}

// fill content of online trip
function onlineTripSearchHistoryContent(item) {
  return `
    <div class="search-history__title">
      <span style="direction: ${item.dir}">${item.origin.tripTitle}</span><i class="${item.dir === 'ltr' ? 'icon-right' : 'icon-left'}"></i><span style="direction: ${item.dir}">${item.destination.tripTitle}
      </span>
    </div>
    <div class="search-history__subtitle">${moment(item.tripStartDateEn).format("jDD jMMMM")} تا ${moment(item.tripEndDateEn).format("jDD jMMMM")
    }</div>
  `
}

// fill content of trip tab
function tripSearchHistoryContent(item) {
  if (item.tourType === 'online') {
    return `
      <div class="search-history__title">
        <span style="direction: ${item.dir}">${item.origin.tripTitle}</span><i class="${item.dir === 'ltr' ? 'icon-right' : 'icon-left'}"></i><span style="direction: ${item.dir}">${item.destination.tripTitle}
        </span>
      </div>
      <div class="search-history__subtitle">${moment(item.tripStartDateEn).format("jDD jMMMM")} تا ${moment(item.tripEndDateEn).format("jDD jMMMM")
      }</div>
    `
  }
  else return `
    <div class="search-history__title">
      <span>${item.title}</span>
    </div>
  `
}

// fill content of insurance tab
function insuranceSearchHistoryContent(item) {
  return `
    <div class="search-history__title">
      <span>${item.country.value}</span>
    </div>
    <div class="search-history__subtitle">${item.durationText} ${item.personCount} نفر</div>
  `
}

// fill content of cip tab
function cipSearchHistoryContent(item) {
  let length = item.date.length
  return `
    <div class="search-history__title">
      <span>${item.ciLlocation.title}</span>
    </div>
    <div class="search-history__subtitle">${item.date.reduce(
    (string, date, index) => {
      return string += `${moment(date).format("jDD jMMMM")}${index !== length - 1 ? '-' : ''}`
    },
    '',
  )
    }</div>
  `
}

// fill content of travel service tab
function travelServiceSearchHistoryContent(item) {
  return `
    <div class="search-history__title">
      <span>${item.title}</span>
    </div>
  `
}

// fill content of rail tab
function railSearchHistoryContent(item) {
  return `
    <div class="search-history__title">
      <span>${item.fromCity.title}</span><i class="${item.routeType === 'rail-oneWay' ? 'icon-left' : 'icon-exchange'}"></i><span>${item.toCity.title
    }</span>
    </div>
    <div class="search-history__subtitle">${moment(item.startDateValue).format("jDD jMMMM")}${item.routeType === 'rail-twoWay' ? ` تا ${moment(item.endDateValue).format("jDD jMMMM")}` : ``
    }</div>
  `
}
